$('document').ready(function(){
    //arrivals and departures buttons
    $('.seasonal_flights_results .tab_button').on('click', function(){
        $('.seasonal_flights_results .tab_button, #fligts_data_row .flights_results, #weekdays_container .weekdays_row').toggleClass('active');
        $('#results_headers_airport_from, #results_headers_airport_to').toggle();
    });
    //selector position on load and resize
    if($('.seasonal_flights_results').length){
        let y = $('#arrivals_row .weekday_col.active').position().left;
        if($(window).width() > 767){
            $('#weekday_selector').css('left', y-12);
        }else{
            $('#weekday_selector').css('left', y-18);
        }
        $(window).resize(function(){
            let y;
            if($('#arrivals_row').is(":visible")){
                y = $('#arrivals_row .weekday_col.active').position().left;
            }else{
                y = $('#departures_row .weekday_col.active').position().left;
            }
            if($(window).width() > 767){
                $('#weekday_selector').css('left', y-12);
            }else{
                $('#weekday_selector').css('left', y-18);
            }
        });
    }
    //selector position on click
    $('.weekday_col').on('click', function(){
        let x = $(this).position().left;
        if($(window).width() > 767){
            $('#weekday_selector').css('left', x-12);
        }else{
            $('#weekday_selector').css('left', x-18);
        }
        $('.weekday_col, .day_container').removeClass('active');
        $('.'+$(this).attr('class').split(' ').join('.')).addClass('active');
        $('.day_container.'+$(this).attr('aria-controls')+'').addClass('active');
    });
});